import React, { useState } from "react";
import { Instruction } from "src/models/Instruction";
import { UserProject } from "src/models/UserProjects";
import {
    SourceDialogContext,
    SourceDialogCurrentProjectContext,
    NewTemplateInstructionsContext,
    InputInstructionHasDependency
} from "src/utils/context";

import NewTemplateDialog from "./NewTemplateDialog";

export default function TemplateCreation() {
    const [sourceDialogOpen, setSourceDialogOpen] = useState(false);
    const [instructionHasDependency, setInstructionHasDependecy] = useState(false);
    const [currentProject, setCurrentProject] = useState<UserProject | undefined>();
    const [templateInstructions, setTemplateInstructions] = useState<Array<Instruction>>([]);

    return (
        <SourceDialogCurrentProjectContext.Provider value={[currentProject, setCurrentProject]}>
            <InputInstructionHasDependency.Provider value={[instructionHasDependency, setInstructionHasDependecy]}>
                <SourceDialogContext.Provider value={[sourceDialogOpen, setSourceDialogOpen]}>
                    <NewTemplateInstructionsContext.Provider value={[templateInstructions, setTemplateInstructions]}>
                        <NewTemplateDialog />
                    </NewTemplateInstructionsContext.Provider>
                </SourceDialogContext.Provider>
            </InputInstructionHasDependency.Provider>
        </SourceDialogCurrentProjectContext.Provider>
    );
}
